import { OAuthUser } from '../../../../site/pbTypes'
import { StorageFormValues } from './validationSchema'

/**
 * Returns the initial/default values for the StorageForm
 * Pre-fills OAuth user data or authenticated customer data if available
 */
export function getInitialStorageFormValues(oauthUser?: OAuthUser, authenticatedCustomer?: any): StorageFormValues {
  return {
    first_name: authenticatedCustomer?.first_name || oauthUser?.rawUser.given_name || '',
    last_name: authenticatedCustomer?.last_name || oauthUser?.rawUser.family_name || '',
    phone: authenticatedCustomer?.phone || '',
    email: authenticatedCustomer?.email || oauthUser?.rawUser.email || '',
    password: oauthUser?.rawUser.email ? '' : '',
    password_confirm: '',
    other_phone: authenticatedCustomer?.other_phone || '',
    other_email: authenticatedCustomer?.other_email || '',
    address_line_1: authenticatedCustomer?.address_line_1 || '',
    address_line_2: authenticatedCustomer?.address_line_2 || '',
    city: authenticatedCustomer?.city || '',
    state: authenticatedCustomer?.state || '',
    zip: authenticatedCustomer?.zip || '',
    driver_lic_front: undefined,
    driver_lic_back: undefined,
    business_name: authenticatedCustomer?.business_name || '',
    emergency_contact_name: authenticatedCustomer?.emergency_contact_name || '',
    emergency_contact_phone: authenticatedCustomer?.emergency_contact_phone || '',
    vehicle_type: '',
    vehicle_year: '',
    vehicle_make: '',
    vehicle_model: '',
    vehicle_lic_state: '',
    vehicle_lic_number: '',
    vin: '',
    description: '',
    proof_of_insurance: undefined,
    move_in_date: '',
    move_out_date: undefined,
    need_24hr_access: false,
    need_3x_week_access: false,
    agree_to_privacy_policy: false,
  }
}
